module.exports = __webpack_public_path__ + "img/p8_3.a84d3c71.png";